module.exports = __webpack_public_path__ + "static/img/risk-group.d61c77d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/risk-group.jpg
// module id = f5KI
// module chunks = 98